import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import styles from "./ProductDetailsPage.module.css";
import { get } from "../../utilities/apiClient";
import { colorCodes } from '../../utilities/settings'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Helmet } from "react-helmet";

import PartialBanner, { IPartialBanner } from "../../components/partialBanner/PartialBanner";
import PartialProductDetailsImgs from "../../components/partialProductDetailsImgs/PartialProductDetailsImgs";
import PartialProductDetailsPrice from "../../components/partialProductDetailsPrice/PartialProductDetailsPrice";
import PartialProductVideo from "../../components/partialProductVideo/PartialProductVideo";
import PartialMoreInfoCard, { IMoreInfo } from "../../components/partialMoreInfoCard/PartialMoreInfoCard";
import DynamicTable from "../../components/dynamicTable/DynamicTable";
import { useLocation } from "react-router-dom";
import PartialProductCard, { IPartialProductCard } from "../../components/partialProductCard/PartialProductCard";
import { selectColorCode } from "../productListingPage/ProductListingPage";
import PartialOfferCard, { IPartialOffer } from "../../components/partialOfferCard/PartialOfferCard";
import MetaComponent from "../../components/metaComponent/MetaComponent";


const webImg = "https://sajkoaonline.blob.core.windows.net/jkoa/carousel/Main-Carousel-Banner-Samsung-mobiles-1920x1080.jpg";
const mobImg = "https://sajkoaonline.blob.core.windows.net/jkoa/carousel/mobile/Main-Carousel-Banner-Samsung-mobiles-mobile-version-375x750px.jpg";
const banner: IPartialBanner = { bannerId: 1, bannerName: "Banner", webImageURL: webImg, mobileImageURL: mobImg }


const sellers = [
    { itemSellerMappingID: 1, logoLink: "https://sajkoaonline.blob.core.windows.net/jkoa/brands/ASUS-logo-1000x1000px.png", sellerLink: "", webSiteLink: "https://www.youtube.com/", displayOrder: 1 },
    { itemSellerMappingID: 2, logoLink: "https://sajkoaonline.blob.core.windows.net/jkoa/brands/Bixolon-1000x1000px.png", sellerLink: "https://www.google.com/", webSiteLink: "https://www.google.com/", displayOrder: 2 },
    { itemSellerMappingID: 3, logoLink: "https://sajkoaonline.blob.core.windows.net/jkoa/brands/FEC-logo-1000x1000px.png", sellerLink: "https://www.google.com/", webSiteLink: "https://www.google.com/", displayOrder: 3 },
    { itemSellerMappingID: 4, logoLink: "https://sajkoaonline.blob.core.windows.net/jkoa/brands/JKOA-logo-1000x1000px.png", sellerLink: "https://www.google.com/", webSiteLink: "https://www.google.com/", displayOrder: 4 }
]


function ProductDetailsPage() {
    const search = useLocation().search;
    const itemCode = new URLSearchParams(search).get('ic');
    const randomColorCode = Math.floor(Math.random() * (3 + 1));

    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);
    const [pageBanner, setPageBanner] = useState<IPartialBanner>(banner);
    const [productImgs, setProductImgs] = useState<any>();
    const [priceDetails, setPriceDetails] = useState<any>();
    const [dealers, setDealers] = useState([])
    const [cardInfo, setCardInfo] = useState<any>();
    const [carousel, setCarousel] = useState<any>();
    const [carouselImgs, setCarouselImgs] = useState<any>();
    const [productVideo, setProductVideo] = useState<any>();
    const [itemSpecs, setItemSpecs] = useState<any>();
    const [relatedProducts, setRelatedProducts] = useState<IPartialProductCard[]>();
    const [promotionHeader, setPromotionHeader] = useState<IPartialOffer>();
    const [colorList, setColorList] = useState<any>([]);
    const [selectedColorId, setSelectedColorId] = useState<any>();

    // meta Data
    const [metaTitle, setMetaTitle] = useState<string>();
    const [metaKeywords, setMetaKeywords] = useState<string>();
    const [metaDescription, setMetaDescription] = useState<string>();

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
        getPageData();
        getRelatedProducts();
    }, [])

    function getPageData() {
        if (itemCode != null || itemCode != undefined) {
            get("WebModule/GetItemDetailsByItemCode", { itemCode: itemCode }, false)
                .then(res => {
                    var response: any = res;
                    if (response.data.statusCode === 200) {
                        if (response.data.result.itemId === 0) {
                            window.location.href = "/home";
                        }
                        if (response.data.result.itemMetaDataList.length > 0) {
                            setMetaTitle(setMeta(response.data.result.itemMetaDataList, 1))
                            setMetaKeywords(setMeta(response.data.result.itemMetaDataList, 2))
                            setMetaDescription(setMeta(response.data.result.itemMetaDataList, 3))
                        }
                        setItemSpecs(response.data.result.itemSpecifications);
                        setPriceDetails(response.data.result);
                        setDealers(response.data.result.sellers);
                        setCardInfo(response.data.result.productDetailCards);
                        setProductImgs(response.data.result.photos);
                        setCarousel(response.data.result.bannerPhotos);
                        setCarouselImgs(response.data.result.bannerPhotos.filter((elm: any) => elm.assetTypeId == 4));
                        setProductVideo(response.data.result.bannerPhotos.filter((elm: any) => elm.assetTypeId == 2));
                        setPromotionHeader(response.data.result.promotionHeader);
                        setColorList(response.data.result.itemColors);
                        // setPageBanner(response.data.result.bannerPhotos[0]);
                    }
                    else {
                        console.log(response.data.errorList)
                    }
                });
        }
    }

    function setMeta(data: any, id: number) {
        var result = data.filter((a: any) => a.metaTypeId == id);
        if (result.length != 0) {
            return result[0].metaContent;
        }
        else {
            return null;
        }
    }

    function getRelatedProducts() {
        if (itemCode != null || itemCode != undefined) {
            get("WebModule/GetRelatedProductsByItemCode", { itemCode: itemCode }, true)
                .then(res => {
                    var response: any = res;
                    if (response.data.statusCode === 200) {
                        setRelatedProducts(response.data.result);
                    }
                    else {
                        console.log(response.data.errorList)
                    }
                });
        }
    }

    const selectColor = (event: any) => {
        setSelectedColorId(event);
    }
    return (
        <React.Fragment>
            {/* {!pageBanner ?
                null
                :
                <PartialBanner banner={pageBanner} />
            } */}
            {metaTitle || metaDescription || metaKeywords ?
                <MetaComponent metaTitle={metaTitle} metaDescription={metaDescription} metaKeywords={metaKeywords} />
                : null}
            <div className={`container`}>
                <Row hidden>
                    <Col lg="12" md="12" xs="12" className={`${styles.selectedDetailSection}`} style={{ padding: isWeb ? "4rem 10rem 0rem 10rem" : "4rem 1rem 2rem 1rem" }}>
                        <Row>
                            <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeading}`}>
                                <span>Discover </span>
                            </Col>
                            <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                                <span>OUR PRODUCTS</span>
                            </Col>
                            <Col lg="12" md="12" xs="12">
                                <p>Make the best out of your time and implement solutions that support your growth. We offer a variety of products to improve the efficiency in your business and as well as your home.
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ paddingTop: "0rem", justifyContent: "center" }}>
                    {productImgs != undefined && productImgs.length > 0 ?
                        <Col lg="6" md="12" xs="12">
                            <PartialProductDetailsImgs productCard={productImgs} itemColor={colorList} selectedColorId={selectedColorId} colorCode={colorCodes[randomColorCode]}
                                IsOfferAvailable={priceDetails.isOfferAvailable} IsNewArrival={priceDetails.isNewArrival}></PartialProductDetailsImgs>
                        </Col>
                        : null
                    }
                    {priceDetails != undefined ?
                        <Col lg="6" md="12" xs="12" >
                            <PartialProductDetailsPrice productCard={priceDetails} itemColor={colorList} dealers={dealers}
                                colorCode={colorCodes[randomColorCode]} onChange={selectColor}></PartialProductDetailsPrice>
                        </Col>

                        : null}
                </Row>
                {promotionHeader != undefined && promotionHeader.promotionHeaderId > 0 ?
                    <div className="section-spacer">
                        <Row style={{ padding: "0", margin: isWeb ? "0 3rem" : "0", zIndex: -1, minHeight: "300px" }}>
                            <Col xl="12" lg="12" md="12" xs="12">
                                <PartialOfferCard key={promotionHeader.promotionHeaderId} productCard={promotionHeader}></PartialOfferCard>
                            </Col>
                        </Row>
                    </div>
                    : null
                }
                {/* Specifications */}
                {itemSpecs != undefined && itemSpecs.length > 0 ?
                    <Row style={{ paddingBottom: "20px" }}>
                        <div className={`${styles.carouselHeading}`}>
                            <span>SPECIFICATIONS</span>
                        </div>
                        <DynamicTable data={itemSpecs} head={[]}></DynamicTable>
                    </Row>
                    : null}

                {/* Videos */}
                {productVideo != undefined && productVideo.length > 0
                    && productVideo.length > 0 ?
                    <Row>
                        <div className={`${styles.carouselHeading}`}>
                            <span>VIDEOS</span>
                        </div>
                        <Col lg="10" md="10" xs="10" style={{ marginRight: "auto", marginLeft: "auto" }}>
                            {productVideo.map((item: any, i: any) => {
                                return (
                                    <div key={i} className={`${styles.videoContainer}`} style={{ marginBottom: "40px" }}>
                                        <iframe className={`${styles.videoTag}`} src={item.assetURL} frameBorder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" loading="lazy" allowFullScreen></iframe>
                                    </div>
                                );
                            })}
                        </Col>
                    </Row>
                    : null
                }
                {/* Carousel Images */}
                {carouselImgs != undefined && carouselImgs.length > 0 && carouselImgs.length > 0 ?
                    <Row style={{ paddingBottom: "20px" }}>
                        <div className={`${styles.carouselHeading}`}>
                            <span>PRODUCT IMAGES</span>
                        </div>
                        <Col lg="10" md="10" xs="10" style={{ marginRight: "auto", marginLeft: "auto" }}>
                            <Carousel
                                autoPlay={true}
                                showArrows={true}
                                swipeable={true}
                                showStatus={false}
                                infiniteLoop={true}
                                showIndicators={true}
                                showThumbs={false}
                            >
                                {carouselImgs.map((item: any) => {
                                    // if (item.assetTypeId == 4) {
                                    return (
                                        <div key={item.itemAssetId} style={{ minHeight: isWeb ? "500px" : "150px" }}>
                                            <img src={item.assetURL} alt={item.itemCode + `-img`} />
                                        </div>
                                    );
                                    // }
                                    // else if (item.assetTypeId == 2) {
                                    //     return (
                                    //         <div key={item.itemAssetId}>
                                    //             <iframe className={`${styles.videoTag}`} src={item.assetURL} frameBorder="0"
                                    //                 allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" loading="lazy" allowFullScreen></iframe>
                                    //         </div>
                                    //     );
                                    // }
                                })}
                            </Carousel>
                        </Col>
                    </Row>
                    : null
                }

                {cardInfo != undefined && cardInfo.length > 0 ?
                    cardInfo.map((card: IMoreInfo) => {
                        if (card.typeID == 1 || card.typeID == 3 || card.typeID == 5) {
                            return (
                                <Row>
                                    <PartialMoreInfoCard key={card.itemID} productCard={card}></PartialMoreInfoCard>
                                </Row>
                            )
                        }
                        else if (card.typeID == 2 || card.typeID == 4) {
                            return (
                                <Row>
                                    <PartialProductVideo key={card.itemID} productCard={card} ></PartialProductVideo>
                                </Row>
                            )
                        }
                    })
                    : null
                }

                {/* {carousel != undefined && carousel.length > 0 && carousel.filter((elm: any) => elm.assetTypeId == 4).length == 0
                    && carousel.filter((elm: any) => elm.assetTypeId == 2).length > 0 ?
                    <Row style={{ paddingBottom: "20px" }}>
                        <div className={`${styles.carouselHeading}`}>
                            <span>PRODUCT IMAGES</span>
                        </div>
                        <Col lg="12" md="12" xs="12">
                            {carousel.map((item: any) => {
                                if (item.assetTypeId == 2) {
                                    return (
                                        <div className={`${styles.videoContainer}`}>
                                            <iframe className={`${styles.videoTag}`} src={item.assetURL} frameBorder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" loading="lazy" allowFullScreen></iframe>
                                        </div>
                                    );
                                }
                            })}
                        </Col>
                    </Row>
                    : null
                } */}

                {relatedProducts != undefined && relatedProducts.length > 0 ?
                    <Row style={{ padding: "0", margin: "0", paddingBottom: "30px" }}>
                        <div className={`${styles.carouselHeading}`}>
                            <span>RELATED PRODUCTS</span>
                        </div>
                        {relatedProducts.map((item: IPartialProductCard, index) => {
                            return (
                                <Col xl="3" lg="3" md="6" sm="6" xs="6">
                                    <PartialProductCard key={item.itemId} productCard={item} colorCode={colorCodes[selectColorCode(index)]}></PartialProductCard>
                                </Col>
                            );
                        })}
                    </Row>
                    : null}
            </div>
        </React.Fragment>
    )
}

export default ProductDetailsPage;